import { render, staticRenderFns } from "./date-range-picker.vue?vue&type=template&id=809e52f0&scoped=true"
import script from "./date-range-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-range-picker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./date-range-picker.vue?vue&type=style&index=0&id=809e52f0&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809e52f0",
  null
  
)

export default component.exports